import { Heading, HStack, VStack } from '@chakra-ui/react'
import { faBuilding } from '@fortawesome/free-regular-svg-icons'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../../api/repository/Repository'
import ButtonSelector from '../../../components/ButtonSelector/ButtonSelector'
import Table from '../../../components/Table/Table'
import Toast from '../../../components/Toast/Toast'
import { colors } from '../../../utils/theme/styles'
const branchColumns = [
  {
    id: 'info',
    Header: 'Detalle',
    type: 'clickeable',
    keyValue: 'sSucursal',
  },
  {
    id: 'NombreSucursal',
    Header: 'Sucursal',
  },
  {
    id: 'Comuna',
    Header: 'Comuna',
  },
  {
    id: 'bFacturacionIndependiente',
    Header: 'Factura independiente',
    type: 'boolean',
  },
  {
    id: 'NombreCentroCosto',
    Header: 'Centro de costo',
  },
]
export default function BranchOffices() {
  const navigate = useNavigate()
  const [branchOfficesData, setBranchOfficesData] = useState([])

  const goToCreateIndividual = () => {
    navigate('new-branch-office')
  }
  const goToCreateMassive = () => {
    navigate('massive-branch-office')
  }

  const onClickBranchOffice = (value) => {
    navigate(`office/${value}`)
  }

  const getData = useCallback(async () => {
    await REPOSITORY.wsEmpresa.company
      .getBranchOffices()
      .then((response) => {
        setBranchOfficesData(response.data)
      })
      .catch((error) => {
        setBranchOfficesData([])
        console.error(error)
      })
  }, [])

  useEffect(() => {
    getData()
    return () => {
      setBranchOfficesData([])
    }
  }, [])

  return (
    <VStack alignItems="flex-start" spacing="24px">
      <Table
        data={branchOfficesData}
        columns={branchColumns}
        onEmployeeClick={onClickBranchOffice}
      />
      <Heading variant="h5">Acciones disponibles</Heading>
      <HStack h="56px" w="60%">
        <Toast variant="gray" as="button" onClick={goToCreateIndividual}>
          <ButtonSelector
            icon={faBuilding}
            defaultTextColor={colors.gray[800]}
            label={'Nueva sucursal'}
          />
        </Toast>
        <Toast onClick={goToCreateMassive} variant="gray" as="button">
          <ButtonSelector
            icon={faBuilding}
            defaultTextColor={colors.gray[800]}
            label={'Carga masiva sucursales'}
          />
        </Toast>
      </HStack>
    </VStack>
  )
}
